import React from 'react'
import filter from '../Data'
import FilterCard from './FilterCard'
const Filterprojects = ({category,setcategory}) => {
  return (
    <div className='flex  gap-8 ml-56 lg:gap-4 lg:ml-0'>
       {
        filter.map((ele)=>{
            return <FilterCard key={ele.id} ele={ele} category={category} setcategory={setcategory}/>
        })
       }      
    </div>
  )
}

export default Filterprojects
